import type { Uuid } from '@sibe/utilities/common';
import type { HsGeometry } from '../../graphic-engine-new/geometry/geometry.interface';
import type { HsMaterial } from '../materials/material.class';
import { HsGraphicObject } from './graphic-object.class';
import type { HsHypersceneTypes } from '../../math-new/types/hyperscene-types.type';

export class HsGraphicSprite extends HsGraphicObject {
  public visible: boolean = true;
  public scale: number = 1;
  public aspect: number = 1;
  public center: HsHypersceneTypes.Array2 = [0, 0];

  constructor(uuid: Uuid, name: string, geometry: HsGeometry, material: HsMaterial) {
    super(uuid, name, geometry, material);
  }

  public updateBoundingSphere(): void {
    this.boundingSphere.center.set(0, 0, 0);
    this.boundingSphere.radius = this.scale;
    this.boundingSphere.applyMatrix4(this.worldMatrix);
  }
}
